<template>
  <div v-if="isMobile" class="mobile-banner">
    <connect-domain-banner />
  </div>
</template>
<script>
import { isMobile } from "@/helpers";
import ConnectDomainBanner from "./ConnectDomainBanner.vue";
export default {
  name: "MobileBanner",
  components: {
    ConnectDomainBanner,
  },
  computed: {
    isMobile() {
      return isMobile();
    },
  },
};
</script>
<style lang="scss" scoped>
.mobile-banner {
  & > div {
    // we will show only first banner at a time
    display: none;
    &:first-child {
      display: block;
      margin-bottom: 16px;
    }
  }
}
</style>
